import { combineReducers } from "redux";
import view from "./view";

const certificationsReducer = combineReducers({
  view,
});

export default certificationsReducer;
